import styled from "styled-components";

import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Title } from "components/atoms/Typography";
import ModalButton, { useModalButtonContext } from "components/organisms/ModalButton";
import FormButton from "components/organisms/form/FormButton";
import { useStrombestillingApiMutation } from "hooks/useStrombestillingApi";

export function StoppPurringerButton({ orderId, name }: { readonly orderId: string; readonly name: string }) {
	return (
		<StyledModalButton style={{ fontSize: "30px" }} className="noStyle" title="Stopp purringer" icon={<FontAwesomeIcon color={"#DF7565"} icon={faXmark} />}>
			<ModalContent>
				<Title>Stopp purringer</Title>
				<p>Er du sikker? Dette vil stoppe alle purringer på e-post og SMS for denne bestillingen.</p>
				<p>Kunde: {name}</p>
				<SubmitButton orderId={orderId} />
				<CloseButton />
			</ModalContent>
		</StyledModalButton>
	);
}

function SubmitButton({ orderId }: { readonly orderId: string }) {
	const { close } = useModalButtonContext();
	const mutation = useStrombestillingApiMutation(`/ordre/${orderId}/close`, ["orders"], "POST");

	return (
		<FormButton
			style={{ marginRight: "1rem" }}
			onClick={(e) => {
				mutation.mutate({ status: "MANUELL_BEHANDLING" });
				e.stopPropagation();
				close();
			}}
			label="Stopp purringer"
		/>
	);
}

function CloseButton() {
	const { close } = useModalButtonContext();

	return (
		<FormButton
			onClick={(e) => {
				close();
				e.stopPropagation();
			}}
			label="Avbryt"
		/>
	);
}

const StyledModalButton = styled(ModalButton)`
	padding: 0 0.5rem;
	border-radius: 1rem;
`;

const ModalContent = styled.div`
	padding: 1rem;
`;
